import React, { useEffect, useState } from "react";
import totalRide from "../../../assets/imgs/total ride.png";
import scheduleRide from "../../../assets/imgs/schedule.png";
import CompletedRide from "../../../assets/imgs/completed ride.png";
import cancelRide from "../../../assets/imgs/cancel ride.png";
import { TabView, TabPanel } from "primereact/tabview";
import ScheduleRide from "./ScheduleRide";
import RideHistory from "./RideHistory";
import { useDispatch, useSelector } from "react-redux";
import { handleGetRequest } from "../../../services/GetTemplate";
const tabChecks = ["total", "upcoming", "completed", "cancelled"]; // Corresponding `check` values for tabs

const MyRide = () => {
    const [userData, setUserData] = useState();
    const [UserUserVehicalData, setUserUserVehicalData] = useState();
    const userId = localStorage.getItem("userId");
    const dispatch = useDispatch();
    const [activeIndex, setActiveIndex] = useState(0);
    const [userVehicalData, setUserVehicalData] = useState([]);
    const [page, setPage] = useState(0);
    const [loading, setLoading] = useState(false);
    const [hasMoreData, setHasMoreData] = useState(true);

    useEffect(() => {
        const fetchDashboardData = async () => {
            try {
                const isDriver = true;
                //  const response = await dispatch(handleGetRequest(`api/paymentHistory/driverHistory?userId=${userId}&pageNumber=${pageNumber}`, true, true));

                const response = await dispatch(handleGetRequest(`api/dashboard/?userId=${userId}&isDriver=${isDriver}`, true, true));
                console.log(response);
                setUserData(response?.data);
            } catch (error) {}
        };
        fetchDashboardData();
    }, []);

    useEffect(() => {
        const fetchUserVehicalData = async () => {
            if (!userId) {
                console.error("UserId is missing!");
                return;
            }

            const params = {
                check: tabChecks[activeIndex], // Use activeIndex to determine the `check` parameter
                isDriver: true,
                page,
            };

            try {
                setLoading(true);
                const response = await dispatch(handleGetRequest(`api/user/schedules?userId=${userId}&check=${params.check}&isDriver=${params.isDriver}&page=${params.page}`, true, true));
                const fetchedData = response?.data || [];
                setUserUserVehicalData((prevData) => (page === 0 ? fetchedData : [...prevData, ...fetchedData]));
                setHasMoreData(fetchedData.length > 4);
            } catch (error) {
                console.error("Error fetching user vehicle data:", error);
            } finally {
                setLoading(false);
            }
        };

        fetchUserVehicalData();
    }, [activeIndex, page]); // Refetch when activeIndex changes
    const loadMoreData = () => {
        if (!loading && hasMoreData) {
            setPage((prevPage) => prevPage + 1);
        }
    };
    const handleTabChange = (e) => {
        setActiveIndex(e.index);
        setPage(0); // Reset to the first page when changing tabs
        setUserUserVehicalData([]); // Clear the data for the new tab
    };
    // console.log(UserUserVehicalData,"UserUserVehicalData");
    return (
        <section>
            <div className="grid ">
                <div className="col-12 sm:col-6 xl:col-3  mb-3 h-full" onClick={() => setActiveIndex(tabChecks.indexOf("total"))} style={{ cursor: "pointer" }}>
                    <div className="card bg-teal-400 p-5">
                        <div>
                            <div className="" style={{ width: "5rem", height: "3rem" }}>
                                <img className="h-full" src={totalRide} />
                            </div>
                            <div className="flex justify-content-between align-items-end text-white">
                                <h5 className="card-text mt-4 mb-1 text-lg">Total Rides</h5>
                                <h2 className="font-bold mb-0 text-2xl">{userData?.totalRides}</h2>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="col-12 sm:col-6 xl:col-3  mb-3 h-full" onClick={() => setActiveIndex(tabChecks.indexOf("upcoming"))} style={{ cursor: "pointer" }}>
                    <div className="card bg-yellow-400 p-5">
                        <div>
                            <div className="" style={{ width: "5rem", height: "3rem" }}>
                                <img className="h-full" src={scheduleRide} />
                            </div>
                            <div className="flex justify-content-between align-items-end text-white">
                                <h5 className="card-text mt-4 mb-1 text-lg">Upcoming Rides</h5>
                                <h2 className="font-bold mb-0 text-2xl">{userData?.upcomingRides}</h2>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="col-12 sm:col-6 xl:col-3  mb-3 h-full" onClick={() => setActiveIndex(tabChecks.indexOf("completed"))} style={{ cursor: "pointer" }}>
                    <div className="card bg-green-400 p-5">
                        <div>
                            <div className="" style={{ width: "5rem", height: "3rem" }}>
                                <img className="h-full" src={CompletedRide} />
                            </div>
                            <div className="flex justify-content-between align-items-end text-white">
                                <h5 className="card-text mt-4 mb-1 text-lg">Completed Rides</h5>
                                <h2 className="font-bold mb-0 text-2xl">{userData?.completedRides}</h2>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="col-12 sm:col-6 xl:col-3  mb-3 h-full" onClick={() => setActiveIndex(tabChecks.indexOf("cancelled"))} style={{ cursor: "pointer" }}>
                    <div className="card bg-orange-300 p-5">
                        <div>
                            <div className="" style={{ width: "5rem", height: "3rem" }}>
                                <img className="h-full" src={cancelRide} />
                            </div>
                            <div className="flex justify-content-between align-items-end text-white">
                                <h5 className="card-text mt-4 mb-1 text-lg">Cancelled Rides</h5>
                                <h2 className="font-bold mb-0 text-2xl">{userData?.cancelledRides}</h2>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="">
                <TabView className="card-panel-view p-3 border-200 border-3 border-round" activeIndex={activeIndex} onTabChange={handleTabChange}>
                    {tabChecks.map((check, index) => (
                        <TabPanel key={index} header={check.charAt(0).toUpperCase() + check.slice(1)}>
                            <ScheduleRide data={UserUserVehicalData} />
                            {loading && <p>Loading...</p>}
                            {hasMoreData && (
                                <button onClick={loadMoreData} className="p-button" style={{ display: "block", margin: "auto" }}>
                                    Load Rides
                                </button>
                            )}
                        </TabPanel>
                    ))}
                </TabView>
            </div>
        </section>
    );
};

export default MyRide;
